var _style, _path, _path2, _g, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st1{fill:none;stroke:gray;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(-125.815 -128.802) scale(1.4197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.77 180.41c-23.19 0-41.99 18.8-41.99 41.99v99.88c0 23.19 18.8 41.99 41.99 41.99s41.99-18.8 41.99-41.99V222.4c.01-23.19-18.8-41.99-41.99-41.99zm-13.62 152.08h-13.62v-13.62h13.62zm0-26.67h-13.62V292.2h13.62zm0-26.67h-13.62v-13.62h13.62zm0-26.67h-13.62v-13.62h13.62zm0-26.67h-13.62v-13.62h13.62zm20.43 106.68h-13.62v-13.62h13.62zm0-26.67h-13.62V292.2h13.62zm0-26.67h-13.62v-13.62h13.62zm0-26.67h-13.62v-13.62h13.62zm0-26.67h-13.62v-13.62h13.62zm20.43 106.68h-13.62v-13.62h13.62zm0-26.67h-13.62V292.2h13.62zm0-26.67h-13.62v-13.62h13.62zm0-26.67h-13.62v-13.62h13.62zm0-26.67h-13.62v-13.62h13.62z",
    id: "path4",
    style: {
      fill: "gray"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.89 199.7s.42-1.25 1.32-3.33c17.73-40.59 71.86-49.26 101.49-16.35 4.75 5.28 9.2 11.75 12.95 19.68",
    id: "path6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.32 192.89s.57-1.75 1.82-4.65c24.33-56.77 98.63-68.9 139.3-22.87 6.53 7.39 12.63 16.43 17.78 27.52",
    id: "path8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    id: "line10",
    d: "M223.73 283.69h152.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.33 264.4v50.69c0 12.19-2.71 24.3-8.43 35.06-7.04 13.25-19.85 27.53-43.05 32.76-7.97 1.8-16.2 1.8-24.17 0-23.19-5.24-36.01-19.51-43.05-32.76-5.72-10.76-8.42-22.87-8.42-35.06V264.4",
    id: "path12"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    id: "line16",
    d: "M299.77 384.26v61.73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    id: "line18",
    d: "M247.56 445.99h104.42"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(-125.815 -128.802) scale(1.4197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 314.44,
    cy: 470.51,
    r: 10.01,
    id: "circle22",
    style: {
      fill: "#65ab65"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.48,
    cy: 470.51,
    r: 10.01,
    id: "circle24",
    style: {
      fill: "#de7c73"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.39,
    cy: 470.51,
    r: 10.01,
    id: "circle26",
    style: {
      fill: "#48b2d2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.35,
    cy: 470.51,
    r: 10.01,
    id: "circle28",
    style: {
      fill: "#e79933"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.7229d1513e3b021680a7a04ef074dcd6.svg";
export { ForwardRef as ReactComponent };